var _defs, _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: "35px",
    height: "35px",
    style: {
      height: "100%",
      width: "100%",
      backgroundImage: "none",
      shapeRendering: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(1, 1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "17.5px 17.5px",
      transform: "rotate(0deg)",
      animation: "1.612903s linear 0s infinite normal forwards running spin-5fea779f-0bb0-416c-8c64-d8a521c2d4bc"
    }
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:.35;}.cls-2{fill:#eb7925;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11.63,
    cy: 17.5,
    cx: 17.5,
    className: "cls-1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.42,1.02l1.23,1.28,2,2.07-2.15,2.18-1.23,1.28-.62,.64v-2.47s0,0,0,0c-5.54,.88-9.78,5.69-9.78,11.48,0,6.42,5.21,11.63,11.63,11.63s11.63-5.21,11.63-11.63c0-5.54-3.88-10.18-9.07-11.35l1.43-1.49,.3-.31-.55-.57-.58-.6c6.58,1.45,11.5,7.31,11.5,14.32,0,8.1-6.56,14.66-14.66,14.66S2.84,25.6,2.84,17.5C2.84,10.03,8.43,3.86,15.65,2.95c0,0,0,0,0,0V.22l.77,.8Z",
    className: "cls-2",
    style: {
      fill: "rgb(235, 121, 37)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "spin-5fea779f-0bb0-416c-8c64-d8a521c2d4bc",
    "data-anikit": ""
  }, "@keyframes spin-5fea779f-0bb0-416c-8c64-d8a521c2d4bc\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.5856,0.0703,0.4143,0.9297);\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.ce819551dc6483232fbce8b32744672d.svg";
export { ForwardRef as ReactComponent };